var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modalPopupLayout",
    class: {
      'active': _vm.visible
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.docType == 'option',
      expression: "docType=='option'"
    }],
    staticClass: "documentOption contentWrap"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.readonly ? '문서설정' : '문서정보'))]), _c('div', {
    staticClass: "overflow content"
  }, [_c('div', {
    staticClass: "option"
  }, [_c('h3', [_vm._v("· 공개정보 설정")]), _c('div', {
    staticClass: "btns"
  }, [_vm.typeChanger ? _c('TypeSelector', {
    attrs: {
      "selected": _vm.processType
    },
    on: {
      "change": function (item) {
        return _vm.changeType(item);
      }
    }
  }) : _vm._e(), !_vm.readonly ? _c('button', {
    on: {
      "click": _vm.processDelete
    }
  }, [_vm._v("공정도 삭제")]) : _vm._e()], 1), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("항목")]), _c('th', [_vm._v("정보")]), !_vm.readonly ? _c('th', [_vm._v("공개")]) : _vm._e()])]), _c('tbody', [_vm._l(_vm.defaultData, function (value, key) {
    return _vm.userData[key] || _vm.activeData[key] ? _c('tr', [_c('td', [_vm._v(_vm._s(value.name))]), _c('td', [_vm._v(_vm._s(!_vm.userData[key] ? _vm.activeData[key] : _vm.userData[key]))]), !_vm.readonly ? _c('td') : _vm._e()]) : _vm._e();
  }), _vm._l(_vm.userTableData, function (value, key) {
    return !_vm.readonly ? _c('tr', [_c('td', [_vm._v(_vm._s(value.name))]), _c('td', [_vm._v(_vm._s(_vm.userData[key]))]), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.activeData[value.activeKey],
        expression: "activeData[value.activeKey]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.activeData[value.activeKey]) ? _vm._i(_vm.activeData[value.activeKey], null) > -1 : _vm.activeData[value.activeKey]
      },
      on: {
        "change": function ($event) {
          var $$a = _vm.activeData[value.activeKey],
              $$el = $event.target,
              $$c = $$el.checked ? true : false;

          if (Array.isArray($$a)) {
            var $$v = null,
                $$i = _vm._i($$a, $$v);

            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.activeData, value.activeKey, $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.activeData, value.activeKey, $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.activeData, value.activeKey, $$c);
          }
        }
      }
    })])]) : _vm._e();
  }), _vm._l(_vm.userTableData, function (value, key) {
    return _vm.readonly && _vm.activeData[value.activeKey] ? _c('tr', [_c('td', [_vm._v(_vm._s(value.name))]), _c('td', [_vm._v(_vm._s(_vm.userData[key]))])]) : _vm._e();
  })], 2)])]), !_vm.readonly ? _c('div', {
    staticClass: "option"
  }, [_c('h3', [_vm._v("· 공저자 정보 (총 " + _vm._s(_vm.myCoauthors.length) + "명)")]), _c('button', {
    on: {
      "click": function ($event) {
        _vm.docType = 'coauthor';
      }
    }
  }, [_vm._v("추가/삭제 하기")]), _c('table', [_vm._m(0), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.userData['loginId']))]), _c('td', [_vm._v(_vm._s(_vm.userData['name']))]), _c('td', [_vm._v("관리자")])]), _vm._l(_vm.myCoauthors, function (coauthor) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(coauthor.loginId))]), _c('td', [_vm._v(_vm._s(coauthor.name))]), _c('td', [_vm._v("공저자권한")])]);
  })], 2)])]) : _vm._e()]), _c('button', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")]), _c('div', {
    staticClass: "ctrl"
  }, [_c('button', {
    staticClass: "confirm",
    on: {
      "click": _vm.confirmCheck
    }
  }, [_vm._v("완료")])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.docType == 'coauthor',
      expression: "docType=='coauthor'"
    }],
    staticClass: "documentOption contentWrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("공저자 추가/삭제")]), _c('div', {
    staticClass: "searchInput"
  }, [_c('span', [_vm._v("검색어")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.collaboratorName,
      expression: "collaboratorName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.collaboratorName
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getCollaborator.apply(null, arguments);
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.collaboratorName = $event.target.value;
      }
    }
  }), _c('button', {
    on: {
      "click": _vm.getCollaborator
    }
  }, [_vm._v("검색")])])]), _c('div', {
    staticClass: "overflow content"
  }, [_c('div', {
    staticClass: "option"
  }, [_c('table', [_vm._m(1), _c('tbody', _vm._l(_vm.coauthors, function (coauthor) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(coauthor.loginId))]), _c('td', [_vm._v(_vm._s(coauthor.name))]), _c('td', [_vm._v(_vm._s(coauthor.companyName))]), _c('td', [_c('input', {
      attrs: {
        "type": "checkbox",
        "readonly": coauthor.readOnly
      },
      domProps: {
        "checked": coauthor.collaborator
      },
      on: {
        "change": function (e) {
          coauthor.collaborator = e.target.checked;

          _vm.addCollaborator(e, coauthor);
        }
      }
    })])]);
  }), 0)])])]), _c('div', {
    staticClass: "ctrl"
  }, [_c('Pagination', {
    attrs: {
      "pageCnt": _vm.pagingInfo.no,
      "pageTotalCnt": _vm.pagingInfo.total,
      "size": _vm.pagingInfo.size
    },
    on: {
      "click": _vm.selectPageNo
    }
  }), _c('button', {
    staticClass: "confirm",
    on: {
      "click": function ($event) {
        return _vm.collaboratorModify(false);
      }
    }
  }, [_vm._v("저장")])], 1), _c('button', {
    staticClass: "close",
    on: {
      "click": function ($event) {
        return _vm.collaboratorModify(true);
      }
    }
  }, [_vm._v("닫기")])]), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('th', [_vm._v("사용자 ID")]), _c('th', [_vm._v("이름")]), _c('th', [_vm._v("권한")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('th', [_vm._v("사용자 ID")]), _c('th', [_vm._v("이름")]), _c('th', [_vm._v("소속")]), _c('th', [_vm._v("선택")])]);

}]

export { render, staticRenderFns }